import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'home',
    defaultMessage: 'Home',
  },
  partnerList: {
    id: 'partnerList',
    defaultMessage: 'Partner Management',
  },
  filter: {
    name: {
      id: 'partnerList.filter.name',
      defaultMessage: 'Partner Name',
    },
    service: {
      id: 'partnerList.filter.service',
      defaultMessage: 'Service Type',
    },
    tag: {
      id: 'partnerList.filter.tag',
      defaultMessage: 'Tag',
    },
  },
});
